import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { getDirectionsUrl } from '@grandvisionhq/utils';
import { rescheduleAppointmentConfirmationScreenEvent } from '../../../../data-layer/actions.js';
import { useAddToCalendarDlEventDispatcher } from '../../../../data-layer/hooks/use-add-to-calendar-dl-event-dispatcher.js';
import '@grandvisionhq/graphql';
import '../../../../queries/book-appointment.js';
import '../../../../queries/get-calendar-availability.js';
import '../../../../queries/get-time-slots.js';
import '../../../../queries/get-store-offer-by-code.js';
import '../../../../queries/get-user.js';
import '../../../../queries/get-store-opening-times.js';
import '../../../../queries/get-availability-stores-nearby.js';
import 'date-fns';
import '@swc/helpers';
import '@grandvisionhq/stores-v2';
import useStoreOfferByCode from '../../../../hooks/api/use-store-offer-by-code.js';
import '../../../../types/Forms.js';
import { AppointmentCommunicationChannel } from '../../../../types/shared.js';
import { fromArrayToString } from '../../../../utils/from-array-to-string.js';
import useVirtualAppointment from '../../../BookAppointment/hooks/use-virtual-appointment.js';
import { useRescheduleAppointmentContext } from '../../context/context.js';
import { useRoutingContext } from '../../context/RoutingContext/context.js';
import RescheduleAppointmentConfirmation from './RescheduleAppointmentConfirmation.js';

const emptyArray = [];
const RescheduleAppointmentConfirmationContainer = ()=>{
    var ref6;
    const { getLabel , getFormattedLabel  } = useIntl();
    const { appointment , store , selectedTimeSlot , config: { googleMapsApiKey , opco , storesUrl , appointmentTypes , offerFallbackImageUrl  } ,  } = useRescheduleAppointmentContext();
    const [getStoreOfferByCode, storeOfferByCode] = useStoreOfferByCode({
        code: 0
    });
    const [{ isVirtualAppointmentType  }] = useVirtualAppointment();
    const [, { queryParams: { returnPath , returnLabel  } ,  }, ] = useRoutingContext();
    const { isAabWithGroupedAppointmentTypesEnabled  } = useFeatureToggles();
    var ref1, ref2;
    const labels = React.useMemo(()=>{
        var ref, ref5;
        return {
            title: (appointment === null || appointment === void 0 ? void 0 : appointment.isReservation) ? getFormattedLabel('appointments.page.reschedule.reservation.title', {
                labelData: {
                    name: (ref1 = appointment === null || appointment === void 0 ? void 0 : (ref = appointment.invitee) === null || ref === void 0 ? void 0 : ref.firstName) !== null && ref1 !== void 0 ? ref1 : ''
                }
            }) : getFormattedLabel('appointments.page.reschedule.confirm.title', {
                labelData: {
                    name: (ref2 = appointment === null || appointment === void 0 ? void 0 : (ref5 = appointment.invitee) === null || ref5 === void 0 ? void 0 : ref5.firstName) !== null && ref2 !== void 0 ? ref2 : ''
                }
            }),
            subtitle: (appointment === null || appointment === void 0 ? void 0 : appointment.isReservation) ? getLabel('appointments.page.reschedule.reservation.subtitle') : getLabel('appointments.page.reschedule.confirm.subtitle'),
            confirmation: (appointment === null || appointment === void 0 ? void 0 : appointment.isReservation) ? getLabel('appointments.page.reschedule.reservation.confirmation') : getLabel('appointments.page.reschedule.confirm.confirmation'),
            additionalInformation: getLabel('appointments.page.reschedule.confirm.additionalInformation'),
            addToCalendar: getLabel('appointments.page.reschedule.confirm.addToCalendar'),
            where: getLabel('appointments.page.reschedule.confirm.where'),
            who: getLabel('appointments.page.reschedule.confirm.who'),
            cantMakeIt: getLabel('appointments.page.reschedule.confirm.cantMakeIt'),
            getDirections: getLabel('appointments.page.reschedule.confirm.getDirections'),
            returnLabel: getLabel('appointments.page.cancel.reschedule.closeButtonLabel.backHome'),
            confirmationEmailInstruction: getFormattedLabel('appointments.page.reschedule.confirm.confirmationEmailInstruction', {
                parseLink: true
            }),
            notification: (appointment === null || appointment === void 0 ? void 0 : appointment.preferredChannelOfCommunication) === AppointmentCommunicationChannel.EMAIL ? getLabel('appointments.page.cancel.confirm.notification.email') : getLabel('appointments.page.cancel.confirm.notification.sms'),
            child: getLabel('appointments.component.appointmentOverview.child')
        };
    }, [
        appointment,
        getLabel,
        getFormattedLabel
    ]);
    const directionsUrl = store ? getDirectionsUrl({
        streetName: store.streetName,
        town: store.town,
        opco
    }) : undefined;
    const appointmentConfirmationContent = React.useMemo(()=>{
        var ref9, ref7, ref8;
        const appointmentContent = isAabWithGroupedAppointmentTypesEnabled ? (ref9 = appointmentTypes) === null || ref9 === void 0 ? void 0 : ref9.reduce((acc, appointmentGroup)=>{
            appointmentGroup.appointmentTypes.forEach((entry)=>{
                if (entry.appointmentConfirmationContent) {
                    acc[entry.typeId] = entry.appointmentConfirmationContent;
                }
            });
            return acc;
        }, {}) : (ref7 = appointmentTypes) === null || ref7 === void 0 ? void 0 : ref7.find((content)=>{
            var ref;
            return content.typeId === (appointment === null || appointment === void 0 ? void 0 : (ref = appointment.appointmentType) === null || ref === void 0 ? void 0 : ref.id);
        });
        return (ref8 = appointmentContent) === null || ref8 === void 0 ? void 0 : ref8.appointmentConfirmationContent;
    }, [
        isAabWithGroupedAppointmentTypesEnabled,
        appointmentTypes,
        appointment === null || appointment === void 0 ? void 0 : (ref6 = appointment.appointmentType) === null || ref6 === void 0 ? void 0 : ref6.id
    ]);
    React.useEffect(()=>{
        if (!store) {
            return;
        }
        getStoreOfferByCode({
            variables: {
                code: Number(store.code)
            }
        });
    }, [
        getStoreOfferByCode,
        appointment,
        store
    ]);
    React.useEffect(()=>{
        if (appointment && store) {
            var ref, ref10;
            var ref11, ref12;
            const dataLayerEvent = rescheduleAppointmentConfirmationScreenEvent({
                appointment: {
                    startTime: appointment.startTime,
                    endTime: appointment.endTime,
                    appointmentType: {
                        id: (ref11 = (ref = appointment.appointmentType) === null || ref === void 0 ? void 0 : ref.id) !== null && ref11 !== void 0 ? ref11 : '',
                        ageGroup: (ref12 = (ref10 = appointment.appointmentType) === null || ref10 === void 0 ? void 0 : ref10.ageGroup) !== null && ref12 !== void 0 ? ref12 : 'ADULT'
                    }
                },
                store
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        appointment,
        store
    ]);
    const appointmentType = React.useMemo(()=>{
        return !(appointment === null || appointment === void 0 ? void 0 : appointment.appointmentType) ? undefined : {
            id: appointment.appointmentType.id,
            ageGroup: appointment.appointmentType.ageGroup
        };
    }, [
        appointment === null || appointment === void 0 ? void 0 : appointment.appointmentType
    ]);
    const { pushAddToCalendarDlEvent  } = useAddToCalendarDlEventDispatcher({
        appointmentCondition: 'new',
        type: appointmentType,
        store,
        isVirtualAppointment: isVirtualAppointmentType(appointment === null || appointment === void 0 ? void 0 : appointment.appointmentType),
        timeSlot: selectedTimeSlot
    });
    if (!appointment) {
        // TODO: add empty screen in scope of the ticket https://jira.grandvision.global/browse/GAAB-3886
        return null;
    }
    var _data, ref3, ref4;
    return /*#__PURE__*/ React.createElement(RescheduleAppointmentConfirmation, {
        labels: labels,
        appointment: appointment,
        store: store,
        offers: (_data = storeOfferByCode.data) !== null && _data !== void 0 ? _data : emptyArray,
        timeSlot: selectedTimeSlot,
        googleMapsApiKey: googleMapsApiKey,
        directionsUrl: directionsUrl,
        storesUrl: storesUrl,
        appointmentConfirmationContent: appointmentConfirmationContent,
        offerFallbackImageUrl: offerFallbackImageUrl,
        isVirtualAppointmentType: isVirtualAppointmentType(appointment.appointmentType),
        returnPath: (ref3 = fromArrayToString(returnPath)) !== null && ref3 !== void 0 ? ref3 : '/',
        returnLabel: (ref4 = fromArrayToString(returnLabel)) !== null && ref4 !== void 0 ? ref4 : labels.returnLabel,
        onICSButtonClick: pushAddToCalendarDlEvent
    });
};

export { RescheduleAppointmentConfirmationContainer as default };
//# sourceMappingURL=RescheduleAppointmentConfirmationContainer.js.map
